import React, { useRef } from "react";

import { FaBell } from "react-icons/fa";
import { RxHamburgerMenu } from "react-icons/rx";
import { useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import MenuDrawer from "./MenuDrawer";
import { IoIosLogOut, IoIosSettings } from "react-icons/io";
import { colors, getLocalStorageItem } from "../Utils/Index";
import { Badge, Tooltip } from "antd";
import NotificationDrawer from "./NotificationDrawer";
import { getNavItems, shouldShowSetting } from "./NavItems";
import { useBrand } from "../Context/BrandContext";
import { ImageUrl } from "../ApiService/Axios/Index";
import UseSocket from "../Hooks/UseSocket";
import Logo from "../Assets/logo.jpg";

const ProjectLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const brand = useBrand();
  const [notificationCount, setNotificationCount] = useState(0);
  const navItems = getNavItems();
  const showSetting = shouldShowSetting();

  const [openMenuDrawer, setOpenMenuDrawer] = useState(false);
  const [openNotficationDrawer, setOpenNotificationDrawer] = useState(false);

  // Track whether we've seen a payload yet, and the latest known order id,
  // so we can tell "just connected" apart from "a new order arrived".
  const hasReceivedFirstPayload = useRef(false);
  const lastOrderIdRef = useRef(null);

  UseSocket(
    "restaurant",
    (data) => {
      console.log("New Notification:", data);

      const latestOrder = data?.recentOrders?.[0];
      const latestOrderId = latestOrder?.id;

      // First payload after connecting is just the initial dashboard
      // snapshot — record the baseline order id but don't treat it as
      // a new notification.
      if (!hasReceivedFirstPayload.current) {
        hasReceivedFirstPayload.current = true;
        lastOrderIdRef.current = latestOrderId ?? null;
        return;
      }

      // Only increment the badge when the top order id has actually
      // changed since the last payload — i.e. a genuinely new order.
      if (
        typeof latestOrderId === "number" &&
        latestOrderId !== lastOrderIdRef.current
      ) {
        lastOrderIdRef.current = latestOrderId;
        setNotificationCount((prev) => prev + 1);
      }
    },
    () => { }
  );

  const updateNotificationCount = (count) => {
    setNotificationCount(count);
  };

  return (
    <div>
      {!location.pathname?.includes("customer") &&
        getLocalStorageItem("role") !== "customer" ? (
        <div
          style={{ zIndex: 4 }}
          className="bg-dynmaicBg2 fixed w-full text-dynmaicText h-20 py-3 px-5 flex justify-between items-center"
        >
          <div className="flex justify-start items-center gap-8">
            <RxHamburgerMenu
              onClick={() => setOpenMenuDrawer(true)}
              className="block lg:hidden cursor-pointer text-dynmaicText"
              size={20}
            />
            <NavLink to={"/dashboard"}>
              <p className="text-2xl font-inter font-bold">{
                <img
                  src={brand?.brand?.logo_image || Logo}
                  alt="logo"
                  className="h-16 w-auto rounded-lg"
                />
              }</p>

            </NavLink>
          </div>
          <div className="flex justify-between items-center gap-8 font-inter">
            <div className="hidden text-dynmaicText lg:flex justify-between items-center gap-8">
              {navItems.map((i, index) => {
                return (
                  <NavLink key={index} to={`/${i.to}`}>
                    <p
                      className={`flex ${location?.pathname === `/${i.to}` && "text-brand"
                        } hover:text-brand transition-all cursor-pointer justify-center items-center gap-2`}
                    >
                      {i.icon} {i.name}
                    </p>
                  </NavLink>
                );
              })}
              {showSetting && (
                <Tooltip arrow={false} title="Setting" placement="right">
                  <IoIosSettings
                    onClick={() => navigate("/setting")}
                    size={25}
                    className="cursor-pointer"
                  />
                </Tooltip>
              )}
              <Badge size="small" color={colors.red} count={notificationCount}>
                <FaBell
                  onClick={() => setOpenNotificationDrawer(!openNotficationDrawer)}
                  size={25}
                  className="cursor-pointer"
                />
              </Badge>
            </div>
            <Badge
              className="cursor-pointer block lg:hidden"
              size="small"
              color={colors.red}
              count={notificationCount}
            >
              <FaBell
                onClick={() =>
                  setOpenNotificationDrawer(!openNotficationDrawer)
                }
                size={25}
                className="cursor-pointer block lg:hidden"
              />
            </Badge>
            <p
              onClick={() => {
                localStorage.clear();
                navigate("/");
              }}
              className={`hidden lg:flex text-xs bg-brand text-dynmaicBg2 rounded-full px-4 py-2 transition-all cursor-pointer justify-center items-center gap-2`}
            >
              LogOut
              <IoIosLogOut />
            </p>
          </div>
        </div>
      ) : (
        <div
          style={{ zIndex: "9999" }}
          className="bg-dynmaicBg fixed w-full text-dynmaicBg2 h-20 py-3 px-8 flex justify-between items-center"
        >
          <div className="flex justify-start items-center gap-8">
            <p className="text-2xl font-inter text-dynmaicText font-bold">Restro</p>
          </div>
          <div className="flex justify-between items-center gap-8 font-inter">
            <p
              onClick={() => {
                localStorage.clear();
                navigate("/");
              }}
              className={`flex text-xs bg-brand text-dynmaicBg2 rounded-full px-4 py-2 transition-all cursor-pointer justify-center items-center gap-2`}
            >
              LogOut
              <IoIosLogOut />
            </p>
          </div>
        </div>
      )}

      {location.pathname?.includes("customer") ? (
        <div
          style={{ zIndex: "9999" }}
          className={`px-5 py-4 h-full min-h-screen pt-[90px] w-full lg:w-1/2 m-auto
       z-[999999] `}
        >
          {children}
        </div>
      ) : (
        <div
          style={{ zIndex: "9999" }}
          className={`px-8 py-4 h-full min-h-screen  pt-[100px]
         z-[999999] `}
        >
          {children}
        </div>
      )}
      {openNotficationDrawer && (
        <NotificationDrawer
          open={openNotficationDrawer}
          setOpen={setOpenNotificationDrawer}
          updateNotificationCount={updateNotificationCount}
        />
      )}
      <MenuDrawer open={openMenuDrawer} setOpen={setOpenMenuDrawer} />
    </div>
  );
};

export default ProjectLayout;
